<template>
    <div class="w3-container w3-responsive">
      <div class="w3-card" style="max-width: 100%; margin: 0">
        <header class="w3-container w3-green">
          <h2>代理链接说明</h2>
        </header>
      </div>
        <div class="w3-container w3-padding-16 w3-text-grey">
         <div class="w3-flex" style="justify-content: space-between">
            <h6>代理链接是您分享给下线用户的专属链接，通过该链接注册的用户将自动成为您的下线用户。</h6>
          </div>   
          <div class="w3-flex" style="justify-content: space-between">
            <h6>可以将代理链接分享到社交媒体、微信群或其他渠道，吸引用户注册成为您的下线用户。</h6>
          </div>         
      </div>
    </div>
  </template>
  
  <script>

  </script>
  
  <style scoped>
  .w3-image {
    display: block;
    margin: 0 auto;
    padding: 20px;
    background: white;
    border: 1px solid #ddd;
  }
  </style>